import { ExportTriggerSettings } from '@y42/json-schema';
import { ImpexChildSettingsModel, ImpexChildState, ImpexChildStoreModel, ImpexChildUIModel } from '@y42/impex';
import type { ExportTriggerJobUIModel } from '../export-trigger-job/export-trigger-job.model';
import type { ExportStoreModel } from '../export/export.model';

export class ExportTriggerSettingsGitModel extends ExportTriggerSettings implements ImpexChildSettingsModel {
  constructor(model: ExportTriggerStoreModel) {
    super();
    const settings = model.settings;
    this.$schema = settings?.$schema || '';
    this.datasource_table_path = settings?.datasource_table_path;
    this.columns = settings?.columns;
    this.target_table = settings?.target_table;

    // TODO list out all possible props and assign one by one (similar to other git models)
    Object.assign(this, settings);
  }
  [key: string]: unknown;

  /**
   * DO NOT MODIFY ANY PROPERTIES HERE.
   * TO LEARN HOW TO MODIFY CLASSES GENERATED FROM JSON-SCHEMA
   * TAKE A LOOK AT https://y42-com.slab.com/posts/working-with-json-schemas-1hz2gcvj
   */
}

export class ExportTriggerStoreModel extends ImpexChildStoreModel<ExportTriggerSettingsGitModel> {
  constructor(model: ExportTriggerStoreModel) {
    super(model);
  }
}

export interface ExportTriggerUIModel
  extends ImpexChildUIModel<ExportTriggerSettingsGitModel, ExportTriggerJobUIModel>,
    ExportTriggerStoreModel {
  export: ExportStoreModel;
}

export interface ExportTriggerState extends ImpexChildState<ExportTriggerStoreModel> {}
